import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { A8Banner234x60 } from '../components/A8Ads';

const ArticlePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">投資コラム: {slug}</h2>
        <Link to="/columns" className="btn-secondary text-sm">← コラム一覧へ</Link>
      </div>
      <article className="prose max-w-none">
        <p>ここに「{slug}」の記事本文を記載します。Markdown対応のCMS等と連携する場合は、このページを差し替えてください。</p>
      </article>
      <div className="card">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">PR</h3>
        <div className="flex flex-wrap gap-3 items-center">
          <A8Banner234x60 />
        </div>
      </div>
    </main>
  );
};

export default ArticlePage;
